import axios from 'axios';
import {V1API} from "../../../_helpers/APIPath";
import {encode, decode} from "../../dataMagic";
import {populateStore, performNetworkCall, buildFormData} from "@/store/asyncHelper";

const keyList = {
    smsUpdate : 'NEWS_UPDATE',
    smsDelete : 'NEWS_DELETE'
};

const mutations = {};
const store = {};

populateStore(store, mutations, keyList, false);

export default {
    namespaced: true,

    state : {
        news: [],
        news_details: {},

        submitSuccess: false,
        newsLoading: false,
        newsError: false,

        ...store
    },

    mutations : {
        ...mutations,

        SET_NEWS(state, results) {
            state.news = results;
        },

        GET_NEWS_DETAILS (state, items) {
            state.news_details = items
        },

        SUBMIT_SUCCESS (state, success) {
            state.submitSuccess = success;
        },

        NEWS_LOADING (state, loading) {
            state.newsLoading = loading;
        },

        NEWS_ERROR (state, hasError) {
            state.newsError = hasError;
        }
    },

    actions: {
        async addNews ({commit, dispatch}, payload) {
            commit('NEWS_LOADING', true);
            commit('NEWS_ERROR', false);

            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token")
                }
            };

            try {
                let response = await axios.post(V1API.create_news, payload.news, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchNews')
                return response

            } catch (e) {
                commit('NEWS_ERROR', true);
            } finally {
                commit('NEWS_LOADING', false);
            }
        },

        async fetchNews ({ commit }) {
            commit('NEWS_LOADING', true);
            commit('NEWS_ERROR', false);

            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token")
                }
            };

            try {
                let result = await axios.get(V1API.news_list, config);
                let response = result.data.data
                commit('SET_NEWS', response);
                return result
            } catch(error) {
                commit('NEWS_ERROR', true);
            } finally {
                commit('NEWS_LOADING', false);
            }
        },

        async getDetails ({ commit }, payload) { 
            let response = await axios.get(V1API.get_news_details + payload).then(result => {
                let items = result.data.data
                commit('GET_NEWS_DETAILS', items)
                return result
            })
            return response
        },

        async updateNews ({commit, dispatch}, payload) {
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token")
                }
            };

            try {
                let response = await axios.patch(V1API.update_news + payload.id, payload.news, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchNews')
                return response

            } catch (e) {
                commit('NEWS_ERROR', true);
            } finally {
                commit('NEWS_LOADING', false);
            }
        },

        async deleteNews({commit, dispatch}, payload) {
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token")
                }
            };

            let response = await axios.delete(V1API.delete_news + payload.delete, config).then(result=>{
                let data = result.data
                return data
            })
            
            dispatch ('fetchNews')
            return response
        },

        async toggleFeatured ({commit, dispatch}, payload) {
            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try{
                let response = await axios.get(V1API.toggle_news_featured + payload.id, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchNews')
                return response

            } catch (e) {

            } finally {

            }
        }
    },

    getters: {}
}
